import { NewsletterSignupProps } from "@made-people/blueprint-newsletter-signup";

export const NewsletterSignup: NewsletterSignupProps = {
  template: "template3",
  form: {
    submitButton: {
      buttonLabel: "SEND",
      variants: {
        style: "solid",
        color: "primary",
        width: "full",
        size: {
          initial: "md",
          lg: "md",
        },
      },
    },
  },
};
